// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__CBzEx","linksList":"style_linksList__zupZf","bulletedListItem":"style_bulletedListItem__1N6aw"};